export enum Experiment {
  UseLocalizationService = 'specs.customFields.UseLocalizationService',
  OOIInEditor = 'specs.membersArea.framelessEditorMyAccount',
  MemberBlockMember = 'specs.membersArea.MemberBlockMember',
}
